import React, { memo } from "react";

import { useNavigate } from "react-router-dom";
import { inject, observer } from "mobx-react";

import { useTheme } from "@mui/material";

const WorkRow = (props) => {
  const navigate = useNavigate();
  const { row } = props;
  const theme = useTheme();
  return (
    <React.Fragment>
      <div
        onClick={() => {
          navigate(`/work/view/${row.code}`);
        }}
        style={{
          backgroundColor: "#ffffff",
          padding: "5px",
          margin: " 15px ",
          borderTopRightRadius: "10px",
          borderBottomRightRadius: "10px",
          borderLeft: "5px solid #2c65ac",
          boxShadow: theme.boxShadow.boxShadow1,
        }}
      >
        <div style={{ minHeight: "70px", margin: "0 5px 0 5px" }}>
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <div className="flex">
              {row?.important}
              {row?.status}
            </div>
            <div>{row.carbs}</div>
          </div>
          <div className="items-center gap-2 ">
            <div>{row.title}</div>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                paddingTop: 5,
                paddingLeft: 4,
              }}
            >
              <div>{row.fat} </div>
              <div
                style={{
                  overflow: "hidden",
                  whiteSpace: "nowrap",
                  textOverflow: "ellipsis",
                  width: "100%",
                  fontSize: 12,
                }}
              >
                {row.calories}
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <div>
        <div style={{ padding: 0, transform: 'translateX(35px)' }} colSpan={6}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Box>
              <div
                align="center"
                width="100%"
                size="medium"
                aria-label="purchases">
                {subLoading ? (
                  <SkeletonSubWorkTable />
                ) : (
                  <div>
                    {subwork
                      ?.filter(item => item?.parent_id === row.code)
                      ?.map(row => (
                        <SubRow key={row.code} row={row} />
                      ))}
                  </div>
                )}
              </div>
            </Box>
          </Collapse>
        </div>
      </div> */}
    </React.Fragment>
  );
};

export default memo(inject("workStore")(observer(WorkRow)));
